module.exports = "<p>\n  Page not found !\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main